module.exports = __webpack_public_path__ + "static/demolition-home_mobile-66df0f9f1b6bc400355ba4d8d1aa192a.png";